<template>
  <el-popover
    v-if="companyList.length > 0"
    popper-class="change-company"
    placement="bottom"
    trigger="click"
    max-width="308px"
    @show="isShowMenu=true"
    @hide="isShowMenu=false"
  >
    <ul class="company-list">
      <li
        v-for="item in companyList"
        :key="item.no"
        class="company-item"
        @click="changeCompany(item.type, item.no)"
      >
        <el-avatar
          :size="22"
          class="comp-logo"
          :src="item.logo || userDefaultAvatar[item.type]"
        ></el-avatar>
        <span
          class="type-name"
          :class="['w_person','w_company','w_team','w_orga'][Number(item.type)]"
        >
            {{['个人','企业','团队/组织','政府'][Number(item.type)]}}
        </span>
        <span
          class="company-name text-hidden "
          :title="item.name"
          :class="{ 'color-c6a56f': (activeCompany.tenantNo || 0) == item.no }"
          >
          <template v-if="item.type==0">
            {{ $parent.userInfo?$parent.userInfo.realName:$parent.userInfo.accountName }}
          </template>
          {{ item.name }}
        </span>
      </li>
    </ul>

    <div class="quickEntry">
      <div @click="to('/UserEnterpriseList')">
        <el-icon class="el-icon-circle-plus"></el-icon>
        加入企业/团队/组织/政府/事业单位
      </div>
      <div @click="to('/authenticationManagement')">
        <el-icon class="el-icon-circle-plus"></el-icon>
        创建企业/团队/组织/政府/事业单位
      </div>
    </div>

    <div class="color66 cursor-pointer select-company" slot="reference">
      <span
        class="width-308 text-hidden"
        style="max-width: 23em"
        :style="{color:isShowMenu?'#B79255 !important':'#666666'}"
        :title="activeCompany.tenantName || '个人中心'"
        >
        <span style="color: #666666 !important;">切换身份：</span>
        {{ activeCompany.tenantName || "个人中心" }}
      </span>
      <i class="el-icon-arrow-up" v-if="isShowMenu" :style="{color:isShowMenu?'#B79255':'#666666'}"></i>
      <i class="el-icon-arrow-down" v-else></i>
    </div>
  </el-popover>
</template>
<script>
import { apiHome } from "@/api/apiHome"
import apiUser from "@/public/apiUser/apiUser"
import qi from "@/assets/public/qi.png"
import tuan from "@/assets/public/tuan.png"
export default {
  data() {
    return {
      companyList: [],
      qi,
      tuan,
      userDefaultAvatar:[
        require('@/assets/header-icon/person.png'),
        require('@/assets/header-icon/company.png'),
        require('@/assets/header-icon/team.png'),
        require('@/assets/header-icon/orga.png'),
      ],
      isShowMenu:false,
    }
  },
  inject: ["reload"],
  components: {},
  computed: {
    activeCompany() {
      //
      return this.$store.state.authUser
    }
  },
  mounted() {
    this.getCompanyList()
  },
  methods: {
    async getCompanyList() {
      let res = await apiHome.getUserCompany()
      if (res.data.code == 200) {
        let data = res.data.data
        this.companyList = data.length > 0 && data[0].no != 0 ? data : []
      }
      let res2 = await apiUser.getJurisdiction()
      //
      let auth = res2.data.result || {}
      this.$store.commit("SET_AUTHUSER", auth)
      this.$store.commit("SET_authorization",auth)
    },
    // 切换主企业
    async changeCompany(type, no) {
      let res = await apiHome.NewChangeCompany(type, no)
      if (res.data.code === 0) {
        this.$message({
          message: "切换成功",
          type: "success",
          offset: 40,
          center:true
        })
        window.setTimeout(function() {
          window.location.reload()
        }, 200)
       this.$store.commit("changeauthorization")
      } else {
        this.$message.error(res.data.msg)
      }
    },
    // 跳转到指定地址
    to(path){
      window.open(process.env.VUE_APP_PERSONURL+path,'_blank')
    }
  }
}
</script>
<style lang="scss">
.change-company {
  margin-top: 0px !important;
  padding: 0 !important;
}
</style>
<style lang="scss" rel="stylesheet/scss" scoped>
.color66 {
  color: #666;
}
.company-list {
  margin: 0;
  padding: 5px 10px;
  max-height: 550px;
  overflow-y: auto;
}
.company-item {
  padding: 5px 0;
  //height: 30px;
  line-height: 1;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
  .comp-logo {
    margin-right: 5px;
    vertical-align: middle;
    width: 20px !important;
    height: 20px !important;

    img{
      width: 22px;
      height: 22px;
    }
  }
  .company-name {
    display: inline-block;
    max-width: 239px;
    vertical-align: middle;
  }
}
.color-c6a56f {
  color: #c6a56f;
}
.width-308 {
  display: inline-block;
  vertical-align: middle;
  max-width: 308px;
  height: 16px;
  line-height: 12px;
}
.select-company {
  > i {
    vertical-align: middle;
    margin-left: 3px;
  }
}
.text-hidden {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.type-name {
  display: inline-block;
  text-align: center;
  //width: 26px;
  height: 16px;
  border-radius: 2px;
  line-height: 16px;
  margin-right: 5px;
  font-size: 10px;
  //padding: 2px 3px 5px;
  padding: 3px;
}
.team-color {
  background-color: rgba($color: #409ee9, $alpha: 0.1);
  color: #409ee9;
}
.company-color {
  color: #67ba63;
  background: #f0f8ef;
}
.quickEntry {
  color: #0286DF;
  font-size: 12px;

  >div{
    border-top: 1px solid #fff;
    display: flex;
    align-items: center;
    padding: 0 10px;
    height: 34px;
    background: #F5F5F5;
  }
  i{
    margin-right: 10px;
    font-size: 20px;
  }
}
.w_company {
  color: #67BA63;
  background: rgba(103, 186, 99, .1);
}

.w_team {
  color: #0286DF;
  background: rgba(2, 134, 223, .1);
}

.w_orga {
  color: #FB9600;;
  background: rgba(251, 150, 0, .1);
}

.w_person {
  color: #409EE9;
  background: rgba(64, 158, 233, .1);
}
::-webkit-scrollbar {
  width: 4px !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
